import {
  StarsData,
  StarsElement,
} from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext } from "react";
import StarIcon from "../../arbiter-icon/misc_star_icon.svg";
import { ReviewsRating } from "../../five-star-row/reviews-rating";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewsStars = memo(function ReviewsStars({
  element,
  setData,
  data,
  showRequired,
}: {
  element: StarsElement;
  setData: (data: StarsData) => void;
  data?: StarsData;
  showRequired: boolean;
}) {
  const brandKit = useContext(BrandKitContext);

  //const [value, setValue] = useState("");

  const fontFamily = brandKit.font.fontFamily;

  return (
    <Flex dir="column" style={{ fontFamily }}>
      <Text fontSize="sm" fontWeight="medium">
        {element.title}
      </Text>
      <ReviewsRating
        editable
        Icon={StarIcon}
        onRatingChange={(rating) => {
          setData?.({ type: element.type, rating });
        }}
        rating={data?.rating}
      />
      {showRequired && element.required && (
        <Text textColor="error">This question is required</Text>
      )}
    </Flex>
  );
});

export const starsInspector: InspectorConfig<StarsElement> = {
  sections: [
    {
      label: "Stars",
      fields: [
        { widget: "toggle", path: "required", label: "Required" },
        { widget: "text", path: "title", label: "Title" },
      ],
    },
  ],
};
